import React from 'react'
import styled from 'styled-components'
import Collapsible from 'react-collapsible'

import ChevronDownIcon from '../icons/ChevronDown'

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 40px;

  .Collapsible__contentOuter {
    border-bottom: 1px solid #ebebeb;
  }

  .Collapsible:last-child {
    .Collapsible__contentOuter {
      border-bottom: none;
    }
  }
`

const Trigger = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 40px 0;
  cursor: pointer;
`

const Title = styled.h3`
  line-height: 1.75;
  padding-right: 40px;
  margin: 0;
`

const Content = styled.p`
  padding-bottom: 40px;
  margin: 0;
`

const IconWrapper = styled.div`
  line-height: 35px;

  svg {
    width: 20px;
    color: ${({ theme }) => theme.brand.jungle};
    transition: transform 300ms ease-out;
  }

  .is-open & {
    svg {
      transform: rotate(-180deg);
    }
  }
`

const Accordion = ({ items }) => (
  <Wrapper>
    {items.map((item, index) => (
      <Collapsible
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        trigger={
          <Trigger>
            <Title>{item.title}</Title>
            <IconWrapper>
              <ChevronDownIcon />
            </IconWrapper>
          </Trigger>
        }
      >
        <Content>{item.content}</Content>
      </Collapsible>
    ))}
  </Wrapper>
)

export default Accordion
